import moment from 'moment';
import { get } from 'lodash';

export const getAvailableTimeRanges = state => state.config.timeRanges;

export const getTimeRange = state => getAvailableTimeRanges()[state.config.selectedTimeRange];

export const getAPITimeRange = state => ({
    start: state.config.selectedTimeRange.apiConfig.start(),
    end: state.config.selectedTimeRange.apiConfig.end()
});

export const getAPIConfig = state => state.config.selectedTimeRange.apiConfig;

export const getTimeRangeForUri = (state) => {
    const { start, end } = getAPITimeRange(state);

    return `${moment(start).format('YYYY-MM-DD')}_${moment(end).format('YYYY-MM-DD')}`;
};

export const getApiUrl = state => state.config.apiUrl;

export const getOktaLoginUrl = (state, callback) => {
    const host = get(state, 'router.parsedUrl.host', null);
    const whitelabelDomain = get(state, 'config.whitelabelDomain');
    const whitelabelLoginUrl = get(state, 'config.whitelabelLoginUrl');

    if (whitelabelDomain && whitelabelLoginUrl) {
        const regex = new RegExp(whitelabelDomain);
        if (regex.test(host)) {
            return whitelabelLoginUrl.replace('{callback}', encodeURIComponent(callback));
        }
    }
    return state.config.loginUrl.replace('{callback}', encodeURIComponent(callback));
};
export const getOktaLogoutUrl = (state, callback) => state.config.logoutUrl.replace('{callback}', encodeURIComponent(callback));

export const getPreviousTimeRangeKey = state => state.config.previousTimeRangeKey;

export const getWhitelabelDomain = state => state.config.whitelabelDomain;
export const getObjectiveShadow = state => state.config.objectiveShadow;



// WEBPACK FOOTER //
// ./src/services/config/selectors.js